
import global from '@/assets/js/global'
const data = {}
// 专题专栏
data.ztzlList = [
  { label: '党史学习教育', url: 'https://www.zyshgzb.gov.cn/459386/459573/index.html', imgUrl: global.imageUrl + '/dsxxjy.png' },
  { label: '6+1联动监督', url: 'https://www.zyshgzb.gov.cn/459386/459394/index.html', imgUrl: global.imageUrl + '/ldjd.png' },
  { label: '全国代表达会', url: 'https://www.zyshgzb.gov.cn/459386/459396/index.html', imgUrl: global.imageUrl + '/huazhang.png' }
]
// 公众参与
data.hdjlList = [
  { label: '委员会客厅', bgColor: '#6CA3F3', url: '', icon: 'icon-tiaochawenjuan' },
  { label: '提案线索交互', bgColor: '#6CA3F3', url: '', icon: 'icon-zhengcefagui2' },
  { label: '文史资料征集', bgColor: '#6CA3F3', url: '', icon: 'icon-zhengcefagui2' },
  { label: '网络议政', bgColor: '#f56c6c', url: '', icon: 'icon-book' },
  { label: '豫事来商量', bgColor: '#f56c6c', url: '', icon: 'icon-book' },
  { label: '意见征集', bgColor: '#f56c6c', url: '', icon: 'icon-book' }
]
data.picLiList = [
  { label: '农牧业委员会', url: '/newList?navCode=nmywyh&navName=农牧业委员会', imgUrl: global.imageUrl + '/rd2_1.png' },
  { label: '经济科技法制委员会', url: '/newList?navCode=jjkjfzwyh&navName=经济科技法制委员会', imgUrl: global.imageUrl + '/rd2_2.png' },
  { label: '提案文史学习委员会', url: '/newList?navCode=tawsxxwyh&navName=提案文史学习委员会', imgUrl: global.imageUrl + '/rd2_3.png' },
  { label: '文教卫生民族宗教委员会', url: '/newList?navCode=wjwsmzzjwyh&navName=文教卫生民族宗教委员会', imgUrl: global.imageUrl + '/rd2_4.png' }
]
data.menuList = {
  l1: [
    { label: '政协概况', value: '/newList?navCode=cppccwz-005&navName=政协概况' },
    { label: '政协党建', value: '/newList?navCode=103&navName=政协党建' },
    { label: '会议活动', value: '/newList?navCode=9&navName=会议活动' },
    { label: '政协论坛', value: '/newList?navCode=10&navName=政协论坛' },
    { label: '县区政协', value: '/newList?navCode=45&navName=县区政协' },
  ],
  l2: [
    { label: '政协要闻', value: '/newList?navCode=078&navName=政协要闻' },
    { label: '政协工作', value: '/newList?navCode=101&navName=政协工作' },
    { label: '委员履职', value: '/newList?navCode=6&navName=委员履职' },
    { label: '党派团体', value: '/newList?navCode=100&navName=党派团体' },
    { label: '专题荟萃', value: '/newList?navCode=31&navName=专题荟萃' },
  ],
}
data.menuListApp = [
  { label: '首页', value: '/homePageApp' },
  { label: '政协概况', value: '/newListApp?navCode=cppccwz-005&navName=政协概况' },
  { label: '政协党建', value: '/newListApp?navCode=103&navName=政协党建' },
  { label: '会议活动', value: '/newListApp?navCode=9&navName=会议活动' },
  { label: '政协论坛', value: '/newListApp?navCode=10&navName=政协论坛' },
  { label: '县区政协', value: '/newListApp?navCode=45&navName=县区政协' },
  { label: '政协要闻', value: '/newListApp?navCode=078&navName=政协要闻' },
  { label: '政协工作', value: '/newListApp?navCode=101&navName=政协工作' },
  { label: '委员履职', value: '/newListApp?navCode=6&navName=委员履职' },
  { label: '党派团体', value: '/newListApp?navCode=100&navName=党派团体' },
  { label: '专题荟萃', value: '/newListApp?navCode=31&navName=专题荟萃' },
]
// if (global.tenantCode === '410700000000000001') {
  data.gzcyHttp = 'https://lzpt.hnzx.gov.cn/committeelivingroom-web/#/newHome?areaId=410700'
  data.footerData = {
    partyOrgan: 'https://bszs.conac.cn/sitename?method=show&id=001988629016A150E06310291AAC62F4',//党政机关跳转地址
    organizer: '中国人民政治协商会议河南省新乡市委员会办公室 ',//主办单位
    address: '河南省新乡市人民东路甲一号',//地址
    zipCode: '453003',//邮编
    technicalSupport: '',  //技术支持
    phone: '0373-3699555',  //联系电话
    icpText: '豫ICP备2021002182号-1',//ICP备案号
    icpHttp: 'https://beian.miit.gov.cn/',//ICP备案号跳转地址
    publicSecurityText: '豫公网安备 41070202001151号',//公安备案号
    publicSecurityHttp: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41070202001151',//公安备案号跳转地址
  }
// }
export default {
  data
}
